(function () {
    var rules = [
        {
            description: 'Min number of characters',
            regex: new RegExp('^.{6,}$'),
            required: true
        },{
            description: 'At least one special character',
            regex: new RegExp('^.*[^a-zA-Z0-9]+.*$'),
            required: false
        },{
            description: 'At least one numeric',
            regex: new RegExp('^.*[0-9]+.*$'),
            required: false
        },{
            description: 'Must contain at least one upper and lowercase character',
            regex: new RegExp('^.*(?=.*[a-z])(?=.*[A-Z]).*$'),
            required: false
        }
    ];

    var strengths = {
        Weak: {
            text: 'Weak',
            cssClass: 'weak'
        },
        OK: {
            text: 'OK',
            cssClass: 'ok'
        },
        Strong: {
            text: 'Good',
            cssClass: 'strong'
        },
        VeryStrong: {
            text: 'Very Good',
            cssClass: 'very-strong'
        }
    };

    var elements = {
        passwordInput: document.querySelector('input[type=password].check-strength'),
        passwordStrengthMeter: document.querySelector('.password-strength__meter'),
        passwordStrengthText: document.querySelector('.password-strength__text')
    };

    var strength;

    var checkPassword = function () {
        // Get current password value
        var password = elements.passwordInput.value;
        var matches = 0;

        // Loop through all regex rules
        for (var i = 0; i < rules.length; i++) {

            // Increment number of matches if password matches rule
            if (rules[i].regex.test(password)) {
                matches += 1;
                continue;
            }

            // If password does not match rule but is required,
            // reset number of matches to 0 to result in a weak strength
            if (rules[i].required) {
                matches = 0;
                break;
            }
        }

        // Set strength by number of rule matches
        switch (matches) {
            case 1: strength = strengths.Weak;
                break;
            case 2: strength = strengths.OK;
                break;
            case 3: strength = strengths.Strong;
                break;
            case 4: strength = strengths.VeryStrong;
                break;
            default: strength = strengths.Weak;
        }

        // Set the css class for the strength meter and the strength display text
        elements.passwordStrengthMeter.className = 'password-strength__meter ' + strength.cssClass;
        elements.passwordStrengthText.textContent = strength.text;
    };

    var init = function () {
        if (elements.passwordInput) {
            elements.passwordInput.onkeyup = checkPassword;
        }
    };

    init();
})();
